

































































import {Component, Prop, VModel, Vue} from 'vue-property-decorator';
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";
export type checkBoxType = "DEFAULT" | "SLIDER"

@Component(
	{
		inheritAttrs: false,
    mixins: [CommonInputMixin],
	}
)
export default class PortalCheckbox extends Vue {

  @VModel( { type: Boolean })
  private inputValue!: boolean;

  @Prop({ default: "DEFAULT" })
  private mode!: checkBoxType;

  @Prop({ default: false })
  private hideError!: boolean;

  @Prop({ default: false })
  private checkboxFirst!: boolean;

  @Prop({ required: false, default: function () { return }})
  private change!: () => void

  created() {
      // Inject parent validator to share validation scope
      this.$validator = (this.$parent as any).$validator;
  }

  private applyChange() {
	  this.$emit("change")
	  if (this.change) {
		  this.change()
	  }
  }

}
